"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AnnualPremium = AnnualPremium;
exports.Payment = Payment;
exports.PaymentFrequency = PaymentFrequency;
var _react = _interopRequireDefault(require("react"));
var _formikMiddleware = _interopRequireDefault(require("../../middleware/formikMiddleware"));
var _ModalChargeWizardCalc = require("./ModalChargeWizardCalc.config");
var _TextInputForForm = require("../Wizard/TextInputForForm");
var _DropdownForForm = require("../Wizard/DropdownForForm");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// TEXT INPUT FIELDS START HERE
function AnnualPremium(props) {
  var {
    errors,
    touched,
    values
  } = props;
  var fieldName = 'annualPremium';
  function generateOnChange() {
    return (0, _formikMiddleware.default)().digitFilterChainHandler({
      currencyWithDecimal: true,
      allowDecimals: true
    }).handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().tealium(_ModalChargeWizardCalc.calcName, fieldName).handleBlur();
  }
  return /*#__PURE__*/_react.default.createElement(_TextInputForForm.TextInputForForm, {
    fieldName: fieldName,
    label: "Annual Premium",
    errors: errors,
    touched: touched,
    values: values,
    type: "text",
    inputMode: "numeric",
    maxLength: "10",
    placeholder: "0",
    prepend: true,
    append: false,
    id: _ModalChargeWizardCalc.idPrefix + fieldName,
    onChange: generateOnChange(),
    onBlur: generateOnBlur()
  });
}
function Payment(props) {
  var {
    errors,
    touched,
    values
  } = props;
  var fieldName = 'payment';
  function generateOnChange() {
    return (0, _formikMiddleware.default)().digitFilterChainHandler({
      currencyWithDecimal: true,
      allowDecimals: true
    }).handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().tealium(_ModalChargeWizardCalc.calcName, fieldName).handleBlur();
  }
  return /*#__PURE__*/_react.default.createElement(_TextInputForForm.TextInputForForm, {
    fieldName: fieldName,
    label: "Payment Amount",
    errors: errors,
    touched: touched,
    values: values,
    type: "text",
    inputMode: "numeric",
    maxLength: "10",
    placeholder: "0",
    prepend: true,
    append: false,
    id: _ModalChargeWizardCalc.idPrefix + fieldName,
    onChange: generateOnChange(),
    onBlur: generateOnBlur()
  });
}

// DROPDOWNS START HERE
function PaymentFrequency(props) {
  var {
    values,
    setFieldValue
  } = props;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_DropdownForForm.DropdownForForm, {
    fieldName: "paymentFrequency",
    setFieldValue: setFieldValue,
    values: values,
    label: "Payment Frequency",
    placeholderText: "Select One",
    dataArray: _ModalChargeWizardCalc.dropdownOptions.paymentFrequency,
    calcName: _ModalChargeWizardCalc.calcName
  }));
}